import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';
import { useAuth } from '@/hooks/useAuth';
import { useNotifications } from '@/hooks/useNotifications';
import { cn } from '@/lib/utils';
import { itensDaBarra } from './navegacao';

// Altura da barra (sem o safe-area). Exportada pra quem precisa descontar o
// espaço dela (a Central de Atendimento ocupa a tela inteira).
export const ALTURA_BARRA_INFERIOR = '4rem';

// Barra de navegação inferior do app: as 4 telas mais usadas que o cargo
// permite + "Menu", que abre o drawer com todas.
export function BottomNav() {
  const { pathname } = useLocation();
  const { can } = useAuth();
  const { setOpenMobile, openMobile } = useSidebar();
  const { unreadCount } = useNotifications();
  const itens = itensDaBarra(can);

  return (
    <nav
      aria-label="Navegação principal"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur supports-[backdrop-filter]:bg-card/85"
    >
      <ul className="mx-auto flex h-16 max-w-lg items-stretch">
        {itens.map((item) => {
          const ativo = pathname === item.path;
          const Icon = item.icon;
          const selo = item.path === '/suporte' && unreadCount > 0 ? unreadCount : 0;
          return (
            <li key={item.path} className="flex-1">
              <Link
                to={item.path}
                aria-current={ativo ? 'page' : undefined}
                className="flex h-full flex-col items-center justify-center gap-1 text-[11px] font-medium"
              >
                <span
                  className={cn(
                    'relative flex h-8 w-14 items-center justify-center rounded-full transition-colors',
                    ativo ? 'bg-tertiary/20 text-tertiary' : 'text-text-secondary'
                  )}
                >
                  <Icon size={21} strokeWidth={ativo ? 2.4 : 2} />
                  {selo > 0 && (
                    <span className="absolute right-2 top-0 flex h-4 min-w-4 items-center justify-center rounded-full bg-error px-1 text-[10px] font-bold tabular-nums text-white ring-2 ring-card">
                      {selo > 99 ? '99+' : selo}
                    </span>
                  )}
                </span>
                <span className={ativo ? 'font-semibold text-text-title' : 'text-text-secondary'}>
                  {item.curto ?? item.label}
                </span>
              </Link>
            </li>
          );
        })}
        <li className="flex-1">
          <button
            type="button"
            onClick={() => setOpenMobile(true)}
            aria-expanded={openMobile}
            className="flex h-full w-full flex-col items-center justify-center gap-1 text-[11px] font-medium text-text-secondary"
          >
            <span className="flex h-8 w-14 items-center justify-center rounded-full">
              <Menu size={21} />
            </span>
            Menu
          </button>
        </li>
      </ul>
    </nav>
  );
}
